export * from '@macs-frontend/features/ui/base/header.base-component';
